import { Station } from '@mi-front/core';

import { STREAM_RETENTION_DAYS_DEFAULT } from '../consts';

/**
 * Effective stream lookback window in days for a station:
 * uses `retentionDays` when it is a positive number; otherwise {@link STREAM_RETENTION_DAYS_DEFAULT}.
 */
export function getStationStreamRetentionDays(station: Pick<Station, 'retentionDays'>): number {
  return station.retentionDays || STREAM_RETENTION_DAYS_DEFAULT;
}
